import { Color, DoubleSide, ShaderMaterial } from "three";

// Custom ShaderMaterial
export default new ShaderMaterial({
  uniforms: {
    uDotSpacing: { value: 10.0 },
    uDotSize: { value: 0.05 },
    uDotAlpha: { value: 0.4 },
    uDotColor: { value: new Color(1.0, 1.0, 1.0) },
    uBgColor: { value: new Color(1.0, 1.0, 1.0) },
    uBgAlpha: { value: 0.1 },
  },
  vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    precision highp float;
    uniform float uDotSpacing;
    uniform float uDotSize;
    uniform float uDotAlpha;
    uniform vec3 uDotColor;
    uniform vec3 uBgColor;
    uniform float uBgAlpha;
    varying vec2 vUv;

    void main() {
      vec2 uv = vUv * uDotSpacing;
      vec2 localUV = fract(uv) - 0.5;
      float dist = length(localUV);

      // Create circular mask for the dot
      float mask = smoothstep(uDotSize, uDotSize - 0.01, dist);
      mask = 1.0 - mask;

      // Compose dot and background colors with alpha
      vec4 dot = vec4(uDotColor, uDotAlpha);
      vec4 bg = vec4(uBgColor, uBgAlpha);

      // Blend dot on top of background
      vec4 finalColor = mix(dot, bg, mask);

      gl_FragColor = finalColor;
    }
  `,
  transparent: true,
  side: DoubleSide,
  vertexColors: true,
  opacity: 0.2,
  depthWrite: false,
});

// export default getMaterial;
